import { jsonApi } from './index';

const workspacesAPI = {
  async getAll(params) {
    return (await jsonApi.findAll('workspace', params)).data;
  },
};

export default workspacesAPI;
